var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid39({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77,9.82H5V8.64H6l.33-1.58H5V5.87H6.57L7,3.77H8.2l-.43,2.1H9l.41-2.1h1.25l-.43,2.1h.74V7.06H10L9.62,8.64h1.31V9.82H9.38L9,11.92H7.76l.41-2.1H7l-.42,2.1H5.34ZM7.54,7.06,7.22,8.64H8.41l.31-1.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid39);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_39.1e6e5034f1f82f3baca2b4a375a2f19e.svg";
export { ForwardRef as ReactComponent };